// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../../actions';

// REACT ROUTER
import { Link, withRouter } from 'react-router-dom';

// CUSTOM COMPONENTS
import ToolbarOptionsDisplay from './ToolbarOptionsDisplay';
import TextButton from '../Button/TextButton';
import { StyledRaisedButton } from '../StyledRaisedButton';
import StyledLink from '../StyledLink';
import { StyledToolbar } from './StyledToolbar';
import ServiceListItems from '../ServiceListItems';
import ActivationDialog from '../Dialog/ActivationDialog';

// UTILS
import { getInitialsString } from '../../utils/avatarUtils';
import { constants } from '../../constants/index';

// MATERIAL UI
import { List, ListItem } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import NavArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import Account from 'material-ui/svg-icons/action/account-box';
import Help from 'material-ui/svg-icons/action/help';
import Work from 'material-ui/svg-icons/action/work';
import Forum from 'material-ui/svg-icons/communication/forum';
import Search from 'material-ui/svg-icons/action/search';
import SignOut from 'material-ui/svg-icons/action/power-settings-new';

// MomentJS Setup
const moment = require('moment-timezone');

/*

Props:
• style

*/

class ToolbarOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // loginDialogOpen: null, // must be null to show it hasn't been touched yet
            aboutMenuOpen: false,
            accountActivationDialogOpen: null, // must be null to show it hasn't been touched yet
            height: '0',
            initHide: false,
            initShow: true,
            menuAnchorElement: null,
            menuOpen: false,
            servicesAreFiltered: false,
            value: 1,
            width: '0',
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    // ===============================================
    // LIFECYCLE HOOKS
    // ===============================================

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        this.props.getDBProviders();
        this.props.getDBServices();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.servicesAreFiltered && this.props.userData) {
            // console.log('RUNNING FILTER SERVICES', this.props.userData);
            this.props.filterServicesByStatus(this.props.userData);
            this.setState({
                servicesAreFiltered: true,
            });
        }
        if (
            nextProps.userId &&
            this.props.userId !== nextProps.userId &&
            !this.props.loginDialogOpen &&
            !(nextProps.emailVerified || nextProps.emailIsVerified)
        ) {
            this.setState({
                accountActivationDialogOpen: true,
            });

            console.log('LISTENING FOR VERIFICATION @ NAVBAR');

            this.props.listenForEmailVerification(nextProps.userId);
        }

        if (nextProps.userId && this.props.userId !== nextProps.userId) {
            this.props.getCreditAmount(nextProps.userId);
            const verificationCheck = setInterval(() => {
                if (nextProps.emailVerified || nextProps.emailIsVerified) {
                    return clearInterval(verificationCheck);
                }
                // CHECK TO SEE IF THE USER IS VERIFIED - IF NOT SHOW VERIFICATION PAGE - THIS HANDLES THE SCENARIO WHERE THE USER IS LOGGING IN AND IS NOT ACTIVATED BECAUSE THEY LEFT AUTH EARLY
                if (
                    !this.props.loginDialogOpen &&
                    !(nextProps.emailVerified || nextProps.emailIsVerified)
                ) {
                    clearInterval(verificationCheck);
                    this.setState({
                        accountActivationDialogOpen: true,
                    });

                    console.log('LISTENING FOR VERIFICATION @ NAVBAR');

                    this.props.listenForEmailVerification(nextProps.userId);
                }
            }, 500);
        }
    }

    // =========== END OF LIFECYCLE HOOKS =============

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
        this.props.updateWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    handleShowLogin = () => {
        // console.log('set dialog to open');
        this.props.openLoginDialog();
        // this.setState({
        // 	loginDialogOpen: true
        // })
    };

    handleActivateAccount = () => {
        // console.log('set dialog to open');

        this.setState({
            accountActivationDialogOpen: true,
        });
        // console.log('Opening Activate Account Dialog');
    };

    handleCloseAccountActivationDialog = () => {
        this.setState({
            accountActivationDialogOpen: false,
        });
    };

    // handleCloseLoginDialog = () => {
    // 	this.setState({
    // 		loginDialogOpen: false
    // 	});
    // }

    handleAccountMenuClick = event => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            menuAnchorElement: event.currentTarget,
            menuOpen: true,
        });
    };

    handleAboutMenuClick = event => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            aboutMenuOpen: true,
            menuAnchorElement: event.currentTarget,
        });
    };

    handleExploreServicesClick = event => {
        event.preventDefault();
        // TODO: REMOVE BEFORE LAUNCH - OR SHOW ONLY ON TEST ENV
        this.props.history.push(`/service-explorer`);
        this.props.updateLocation('/service-explorder');
        this.handleMenuClose(); // required for mobile view
    };

    handleMyServicesMenuClick = event => {
        // This prevents ghost click.
        event.preventDefault();
        if (this.state.width > this.props.mediaQ1) {
            this.setState({
                menuAnchorElement: event.currentTarget,
                myServicesMenuOpen: true,
            });
        } else {
            this.props.history.push('/my-services');
            this.props.updateLocation('/my-services');
            this.handleMenuClose();
        }
    };

    handleSearchIconClick = event => {
        event.preventDefault();

        this.setState({
            initHide: !this.state.initHide,
            initShow: !this.state.initShow,
        });
    };

    handleMenuClose = () => {
        this.setState({
            aboutMenuOpen: false,
            menuOpen: false,
            myServicesMenuOpen: false,
        });
    };

    handleServiceSelect = service => {
        // console.log(service,'service')
        this.props.history.push(`/service/modules/${service._id}`);
        this.props.updateLocation(`/service/modules/${service._id}`);
        this.handleMenuClose();

        this.props.setSelectedService(service);

        // REsets/Gets the Thread for the newly selected service.
        // console.log('GETTING THREAD FOR NEW SERVICE @ TOOLBAR...');
        this.props.getMessageThread(this.props.userData, service, threadKey => {
            // console.log('GOT CHANNEL @ TOOLBAR SERVICE SELECT', threadKey);
        });

        // Clears then gets the bookings with the new selected services bookings.
        this.props.loadUpcomingDbBookings({
            serviceId: service._id,
            // clientUid,
            userId: this.props.userId,
            userType: 'client',
        });
    };

    handleHelpClick = () => {
        this.props.history.push(`/help+feedback`);
        this.props.updateLocation(`/help+feedback`);
        this.handleMenuClose();
    };

    handleCompanyDashboardClick = () => {
        this.props.history.push(`/company/dashboard`);
        this.props.updateLocation(`/company/dashboard`);
        this.handleMenuClose();
    };

    handleClientEngagement = () => {
        this.props.history.push(`/modules`);
        this.props.updateLocation(`/modules`);
        this.handleMenuClose();
    };

    handleProviderDashboardClick = userId => {
        this.props.history.push(`/provider/dashboard/${userId}`);
        this.props.updateLocation(`/provider/dashboard/${userId}`);
        this.handleMenuClose();
    };

    render = () => {
        const {
            userData,
            provider,
            credits,
            emailVerified,
            emailIsVerified,
            getClientData,
            history,
            updateLocation,
            logOut,
            clearUserData,
            notifyUser,
            mediaQ1,
            userId,
            color,
            children,
            filteredServices,
            loginDialogOpen,
        } = this.props;

        const { width: screenWidth } = this.state;

        const childNum = React.Children.count(children);
        const {
            activeServices,
            inactiveServices,
            pendingServices,
        } = filteredServices;
        let linkColor = color;

        let buttonMarginRight = null;
        let buttonStyles = null;

        // console.log('ROLES:', userData && userData.roles);
        const isSuperUser =
            userData && userData.roles && userData.roles.superUser;

        if (screenWidth < mediaQ1) {
            buttonStyles = {
                display: 'flex',
                flex: 1,
                height: 48,
                width: '100%',
            };
            buttonMarginRight = {
                ...buttonStyles,
                backgroundColor: constants.color.primary,
                borderRadius: 4,
                color: '#ffffffc7',
                height: 35,
                marginBottom: 5,
            };
        } else {
            buttonStyles = {
                marginRight: 20,
                // marginRight: 15
            };
            buttonMarginRight = {
                ...buttonStyles,
                /* font-weight: bold, */
                /* border: #37f6ff 1 solid, */
                background: 'rgb(67,195,207)' /* Old browsers */,
                background:
                    '-moz-linear-gradient(-45deg, rgb(54, 221, 236) 0%, rgb(24, 212, 218) 100%)' /* FF3.6-15 */,
                background:
                    '-webkit-linear-gradient(-45deg, rgb(54, 221, 236) 0%, rgb(24, 212, 218) 100%)' /* Chrome10-25,Safari5.1-6 */,
                background:
                    'linear-gradient(135deg, rgb(54, 221, 236) 0%, rgb(24, 212, 218) 100%)' /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */,
                borderRadius: 4,
                color: '#ffffffc7',
                filter:
                    "progid:DXImageTransform.Microsoft.gradient( startColorstr='#43c3cf', endColorstr='#48d6db',GradientType=0 )" /* IE6-9 fallback on horizontal gradient */,
                padding: '6px 12px',
                /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#43c3cf+0,46eae5+100 */
            };
        }

        const menuItems = [
            {
                condition:
                    userId &&
                    this.state.accountActivationDialogOpen &&
                    loginDialogOpen !== false, // only show if other dialopg is not open
                jsx: (
                    <ActivationDialog
                        modal={false}
                        open={this.state.accountActivationDialogOpen}
                        handleClose={this.handleCloseAccountActivationDialog}
                    />
                ),
            },
            {
                // SHOW HOME MENU LINK ONLY FOR AUTHENTICATED CONSUMERS
                condition:
                    (this.props.userData && !this.props.userData.provider) ||
                    !this.props.userData, // DO NOT SHOW FOR PROVIDER USERS
                jsx: (
                    <TextButton
                        fontWeight={400}
                        style={buttonStyles}
                        color={linkColor}
                        letterSpacing={0.08}
                        fontSize={14}
                        onClick={() => {
                            this.props.history.push(`/`);
                            this.props.updateLocation('/');
                            this.handleMenuClose(); // required for mobile view
                        }}
                    >
                        Home
                    </TextButton>
                ),
            },
            {
                // SHOW ABOUT LINK ONLY FOR UNAUTHENTICATED CONSUMER
                condition:
                    (this.props.userData && !this.props.userData.provider) ||
                    !this.props.userData, // DO NOT SHOW FOR PROVIDER USERS
                jsx: (
                    <TextButton
                        color={linkColor}
                        fontSize={14}
                        fontWeight={400}
                        style={buttonStyles}
                        onClick={this.handleAboutMenuClick}
                    >
                        About
                    </TextButton>
                ),
            },
            {
                // CONSUMER TOP BAR LINKS - WHEN AUTHENTICATED
                condition:
                    this.props.userId &&
                    this.props.userData &&
                    this.props.userData.email &&
                    this.props.emailVerified &&
                    !userData.isPendingActivation &&
                    !this.props.userData.provider, // first name must be present or else a undefined value will be shown on refresh
                jsx: (
                    <div>
                        <TextButton
                            color={linkColor}
                            fontSize={14}
                            fontWeight={400}
                            style={buttonMarginRight}
                            onClick={this.handleMyServicesMenuClick}
                        >
                            My Services
                        </TextButton>

                        <Popover
                            open={this.state.myServicesMenuOpen}
                            anchorEl={this.state.menuAnchorElement}
                            anchorOrigin={{
                                horizontal: 'left',
                                vertical: 'bottom',
                            }}
                            targetOrigin={{
                                horizontal: 'left',
                                vertical: 'top',
                            }}
                            onRequestClose={this.handleMenuClose}
                            animation={PopoverAnimationVertical}
                            style={{ padding: 0 }}
                        >
                            <List>
                                {activeServices &&
                                    this.props.providers &&
                                    this.props.providers.length > 0 &&
                                    activeServices.length > 0 && (
                                        <ServiceListItems
                                            services={activeServices}
                                            providers={this.props.providers}
                                            header="Active Services"
                                            onServiceSelect={
                                                this.handleServiceSelect
                                            }
                                        />
                                    )}

                                {inactiveServices &&
                                    this.props.providers &&
                                    this.props.providers.length > 0 &&
                                    inactiveServices.length > 0 && (
                                        <ServiceListItems
                                            services={inactiveServices}
                                            providers={this.props.providers}
                                            header="Archived Services"
                                            onServiceSelect={
                                                this.handleServiceSelect
                                            }
                                        />
                                    )}

                                {pendingServices &&
                                    this.props.providers &&
                                    this.props.providers.length > 0 &&
                                    pendingServices.length > 0 && (
                                        <ServiceListItems
                                            divider={
                                                (activeServices &&
                                                    activeServices.length >
                                                        0) ||
                                                (inactiveServices &&
                                                    inactiveServices.length > 0)
                                                    ? true
                                                    : false
                                            }
                                            services={pendingServices}
                                            providers={this.props.providers}
                                            header="Pending Services"
                                            onServiceSelect={
                                                this.handleServiceSelect
                                            }
                                        />
                                    )}
                                {/* { this.props.services && (this.props.services && this.props.services.length == 0) && */}
                                {
                                    // (pendingServices && pendingServices.length > 0) || (inactiveServices && inactiveServices.length > 0) || (activeServices && activeServices.length > 0) &&
                                    <ListItem
                                        // key={'1'}
                                        primaryText={'See all services...'}
                                        onClick={() => {
                                            this.props.history.push(
                                                '/my-services',
                                            );
                                            this.props.updateLocation(
                                                '/my-services',
                                            );
                                            this.handleMenuClose();
                                            this.props.setSelectedService(null);
                                        }}
                                    />
                                }
                                {pendingServices &&
                                    pendingServices.length <= 0 &&
                                    inactiveServices &&
                                    inactiveServices.length <= 0 &&
                                    activeServices &&
                                    activeServices.length <= 0 && (
                                        <ListItem
                                            // key={'1'}
                                            primaryText={
                                                'You have no services yet'
                                            }
                                            disableTouchRipple
                                        />
                                    )}
                            </List>
                        </Popover>
                    </div>
                ),
            },
            {
                // SHOW IF AUTHENTICATED BUT EMAIL IS NOT VERIFIED
                condition:
                    this.props.userId &&
                    !(this.props.emailVerified || this.props.emailIsVerified) &&
                    !isSuperUser,
                jsx: (
                    <div style={{ marginRight: 15 }}>
                        <StyledRaisedButton
                            label="Activate Account"
                            primary={true}
                            onClick={this.handleActivateAccount}
                            disableTouchRipple={true}
                            disableFocusRipple={true}
                            style={{ marginLeft: 30 }} // this is really bad practice dont pass styles in as props!!
                            buttonStyle={{ backgroundColor: '#FFCC00' }}
                            // style={{color: 'blue'}}
                            // labelColor="blue"
                        />
                    </div>
                ),
            },
            {
                // ALWAYS SHOW
                condition: true,
                jsx: (
                    <div>
                        {!this.props.userId && (
                            <StyledRaisedButton
                                label="Get Started"
                                primary={true}
                                onClick={this.handleShowLogin}
                                disableTouchRipple={true}
                                disableFocusRipple={true}
                                style={{ marginLeft: 30 }} // this is really bad practice dont pass styles in as props!!
                                buttonStyle={{ backgroundColor: '#FFCC00' }}
                                // style={{color: 'blue'}}
                                // labelColor="blue"
                            />
                        )}

                        {// ACCOUNT MENU - SHOW IF AUTHENTICATED FOR BOTH PROVIDERS AND CONSUMERS
                        (isSuperUser ||
                            (!!userId &&
                                userData &&
                                userData.email &&
                                !userData.isPendingActivation)) && ( //this.props.emailVerified && // first name must be present or else a undefined value will be shown on refresh
                            <div
                                style={{
                                    backgroundColor: 'rgba(10,10,10,0.1)',
                                    borderRadius: 2,
                                }}
                            >
                                <TextButton
                                    color={linkColor}
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ marginLeft: 20 }}
                                    onClick={this.handleAccountMenuClick}
                                    data-testid="account-options-button"
                                >
                                    <div
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            padding: '4px 0 4px 0',
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginLeft: -10,
                                                marginRight: 7,
                                                position: 'relative',
                                                top: this.props.userData
                                                    .profilePhotoURL
                                                    ? 3
                                                    : 0,
                                            }}
                                        >
                                            <Avatar
                                                src={
                                                    this.props.userData
                                                        .profilePhotoURL
                                                }
                                                size={23}
                                            >
                                                {this.props.userData &&
                                                this.props.userData.firstName &&
                                                this.props.userData.lastName &&
                                                !this.props.userData
                                                    .profilePhotoURL
                                                    ? getInitialsString(
                                                          this.props.userData
                                                              .firstName,
                                                          this.props.userData
                                                              .lastName,
                                                      )
                                                    : null}
                                            </Avatar>
                                        </div>
                                        {`${this.props.userData.firstName} ${
                                            this.props.userData.lastName
                                        }`}
                                        <NavArrowDown
                                            style={{
                                                position: 'relative',
                                                top: 1,
                                            }}
                                            color="gray"
                                        />
                                    </div>
                                </TextButton>
                            </div>
                        )}
                    </div>
                ),
            },
        ];

        const filteredMenuItems = menuItems.filter(item => {
            return item.condition;
        });

        // filteredMenuItems.map(item => {
        // 	return item.jsx
        // })

        return (
            <div
                ref="toolbar"
                style={{ display: 'Flex', alignItems: 'center' }}
            >
                <ToolbarOptionsDisplay mediaQ1={mediaQ1}>
                    {filteredMenuItems.map((item, i) => {
                        return <div key={i}>{item.jsx}</div>;
                    })}
                </ToolbarOptionsDisplay>
                {((userData && !userData.provider) || !userData) && (
                    <Popover
                        open={this.state.aboutMenuOpen}
                        anchorEl={this.state.menuAnchorElement}
                        anchorOrigin={{
                            horizontal: 'left',
                            vertical: 'bottom',
                        }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={this.handleMenuClose}
                        animation={PopoverAnimationVertical}
                    >
                        <Menu>
                            <MenuItem
                                value={1}
                                label="About"
                                primaryText={
                                    <StyledLink
                                        color={'gray'}
                                        styles={{ marginLeft: 30 }}
                                        letterSpacing={0.08}
                                        to={'/about'}
                                    >
                                        About Cyno
                                    </StyledLink>
                                }
                                onClick={() => this.handleMenuClose()}
                            />
                            <MenuItem
                                value={2}
                                label="About Corporate Program"
                                primaryText={
                                    <StyledLink
                                        color={'gray'}
                                        styles={{ marginLeft: 30 }}
                                        letterSpacing={0.08}
                                        to={'/about-corporate'}
                                    >
                                        Corporate Program
                                    </StyledLink>
                                }
                                onClick={() => this.handleMenuClose()}
                            />
                        </Menu>
                    </Popover>
                )}
                <Popover
                    open={this.state.menuOpen}
                    anchorEl={this.state.menuAnchorElement}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.handleMenuClose}
                    animation={PopoverAnimationVertical}
                >
                    <Menu>
                        <MenuItem
                            primaryText="Help &amp; feedback"
                            onClick={this.handleHelpClick}
                            leftIcon={<Help />}
                        />
                        {process.env.REACT_APP_ENV !== 'production' && (
                            <MenuItem
                                primaryText="Explore Services"
                                onClick={this.handleExploreServicesClick}
                                leftIcon={<Search />}
                            />
                        )}

                        {userData &&
                            userData.roles &&
                            (userData.roles.accountAdmin ||
                                userData.roles.staffAdmin) && (
                                <MenuItem
                                    primaryText="Company dashboard"
                                    onClick={this.handleCompanyDashboardClick}
                                    leftIcon={<Work />}
                                />
                            )}
                        {userData &&
                            userData.roles &&
                            (userData.roles.accountAdmin ||
                                userData.roles.staffAdmin) &&
                            userData.roles.provider && (
                                <MenuItem
                                    primaryText="Client Engagement Centre"
                                    onClick={this.handleClientEngagement}
                                    leftIcon={<Forum />}
                                />
                            )}
                        {userData &&
                            userData.roles &&
                            userData.roles.provider && (
                                <MenuItem
                                    primaryText="Provider dashboard"
                                    onClick={() =>
                                        this.handleProviderDashboardClick(
                                            userId,
                                        )
                                    }
                                    leftIcon={<Help />}
                                />
                            )}
                        {userData &&
                            credits &&
                            (emailVerified || emailIsVerified) && (
                                <MenuItem
                                    primaryText={`$${(credits / 100).toFixed(
                                        2,
                                    )} in credits`}
                                    leftIcon={<Account />}
                                />
                            )}
                        <Divider />
                        <MenuItem
                            primaryText="Sign out"
                            onClick={() => {
                                this.handleMenuClose();
                                // setTimeout allows animation to finish before removing the trigger button
                                setTimeout(() => {
                                    getClientData(null);
                                    logOut(history, updateLocation)
                                        .then(res => {
                                            clearUserData();
                                            getClientData(null);
                                            notifyUser({
                                                message:
                                                    'You are now signed out.',
                                                textColor: 'white',
                                                visible: true,
                                            });
                                        })
                                        .catch(console.log);
                                }, 500);
                            }}
                            leftIcon={<SignOut />}
                        />
                    </Menu>
                </Popover>
            </div>
        );
    };
}

const mapStateToProps = ({
    auth,
    service,
    provider,
    router,
    client,
    payment,
}) => {
    // console.log('filteredServices @ Toolbar', service.activeServices, service.pendingServices, service.inactiveServices);
    return {
        credits: payment.credits,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified, // need both verifieds! one is triggered on activation one is permanent from auth user
        filteredServices: {
            activeServices: service.activeServices,
            inactiveServices: service.inactiveServices,
            pendingServices: service.pendingServices,
        },
        location: router.location,
        loginDialogOpen: auth.loginDialogOpen,
        providers: provider.providers,
        selectedService: service.selectedService,
        services: service.services,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.uid : null,
    };
};

export const ToolbarOptionsDisconnected = ToolbarOptions;
export default withRouter(
    connect(
        mapStateToProps,
        actions,
    )(ToolbarOptions),
);
// export { ToolbarSearch as default }



// WEBPACK FOOTER //
// ./src/js/components/ToolbarSearch/ToolbarOptions.jsx